module.exports = __webpack_public_path__ + "img/tune-up-coupon.441501f0.png";